import { styled, keyframes } from '@mui/material/styles';
import { Box, Button, Typography, TextField, Checkbox, IconButton } from '@mui/material';

// ============================================
// Modal Container
// ============================================
export const ModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '976px',
  maxHeight: '90vh',
  backgroundColor: '#fff',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  outline: 'none',
});

// ============================================
// Header
// ============================================
export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 32px',
  height: '56px',
  backgroundColor: '#262626',
  flexShrink: 0,
});

export const ModalHeaderTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  color: '#fff',
});

export const CloseIconButton = styled(Box)({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  '&:hover': {
    opacity: 0.8,
  },
});

// ============================================
// Content
// ============================================
export const ModalContentArea = styled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  alignItems: 'center',
  padding: '32px',
  overflow: 'hidden',
});

export const ContentRow = styled(Box)({
  flex: 1,
  minHeight: 0,
  width: '100%',
  display: 'flex',
  gap: '32px',
  alignItems: 'stretch',
  justifyContent: 'center',
});

// ============================================
// Left Section (문자 설정)
// ============================================
export const LeftSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  alignItems: 'flex-start',
  minHeight: 0,
});

export const FormRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});

export const FormLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  width: '80px',
  flexShrink: 0,
});

export const SelectBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '420px',
  height: '40px',
  padding: '8px 14px',
  border: '1px solid #d9d9d9',
  borderRadius: '6px',
  cursor: 'pointer',
  '&:hover': {
    borderColor: '#bfbfbf',
  },
});

export const SelectText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const PlaceholderText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
  whiteSpace: 'nowrap',
});

// ============================================
// 리스트 보기 버튼 & Popover
// ============================================
export const ViewListButton = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  color: '#4ab3bc',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  '&:hover': {
    textDecoration: 'underline',
  },
});

// ============================================
// 내용 Section
// ============================================
export const ContentSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '516px',
});

export const ContentTitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const TemplateButton = styled(Box)({
  cursor: 'pointer',
  padding: '4px 6px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: 'rgba(74, 179, 188, 0.08)',
  },
});

export const TemplateButtonText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#4ab3bc',
  textAlign: 'center',
  whiteSpace: 'nowrap',
});

export const MessageTextArea = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: '140px',
    alignItems: 'flex-start',
    padding: 0,
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 500,
    '& fieldset': {
      borderColor: '#d9d9d9',
    },
    '&:hover fieldset': {
      borderColor: '#bfbfbf',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4ab3bc',
    },
  },
  '& .MuiInputBase-inputMultiline': {
    height: '100% !important',
    padding: '12px 16px',
    boxSizing: 'border-box',
    overflowY: 'auto !important',
    resize: 'none',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d9d9d9',
      borderRadius: '2px',
    },
  },
});

export const AdCheckboxRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const AdCheckbox = styled(Checkbox)({
  padding: 0,
  width: '20px',
  height: '20px',
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '&.Mui-checked': {
    color: '#4ab3bc',
  },
});

export const AdCheckboxLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
});

// ============================================
// 사진 첨부 Section
// ============================================
export const PhotoRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'flex-start',
  width: '516px',
  // 잔여건수 카드와 시작점을 맞추기 위해 왼쪽 열 하단에 고정 (높이도 카드와 동일하게 64px)
  height: '64px',
  marginTop: 'auto',
  flexShrink: 0,
});

export const PhotoLabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '40px',
  width: '80px',
  flexShrink: 0,
});

export const PhotoFieldColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  width: '420px',
});

export const PhotoSpecHint = styled(Typography)({
  fontSize: '12px',
  lineHeight: 1.5,
  color: '#8c8c8c',
});

export const PhotoAttachArea = styled(Box)({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  width: '420px',
});

export const PhotoDataBox = styled(Box)({
  flex: 1,
  minWidth: 0,
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '0 8px 0 12px',
  border: '1px solid #d9d9d9',
  borderRadius: '6px',
  overflow: 'hidden',
});

export const PhotoDataText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 1,
  minWidth: 0,
});

export const PhotoChipList = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  overflowX: 'auto',
  overflowY: 'hidden',
  height: '100%',
  padding: '0 4px',
  '&::-webkit-scrollbar': {
    height: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#d9d9d9',
    borderRadius: '2px',
  },
});

export const PhotoChip = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  height: '32px',
  padding: '0 4px 0 10px',
  backgroundColor: '#f2f5f5',
  border: '1px solid #e5eeef',
  borderRadius: '16px',
  flexShrink: 0,
  maxWidth: '180px',
});

export const PhotoChipText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  color: '#4ab3bc',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const PhotoCountBadge = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: '#4ab3bc',
  flexShrink: 0,
  padding: '0 4px',
});

export const PhotoRemoveButton = styled(IconButton)({
  width: '20px',
  height: '20px',
  padding: 0,
  color: '#4ab3bc',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'rgba(74, 179, 188, 0.15)',
    color: '#3a9fa8',
  },
});

export const PhotoAttachButton = styled(Button)({
  width: '120px',
  height: '40px',
  borderRadius: '8px',
  border: '1px solid #4ab3bc',
  backgroundColor: '#fff',
  color: '#4ab3bc',
  fontSize: '20px',
  fontWeight: 600,
  textTransform: 'none',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'rgba(74, 179, 188, 0.08)',
    border: '1px solid #4ab3bc',
  },
});

// ============================================
// Right Section (미리보기, 잔여건수)
// ============================================
export const RightSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '360px',
  minHeight: 0,
  alignSelf: 'stretch',
});

export const PreviewContainer = styled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  backgroundColor: '#f2f2f2',
  borderRadius: '20px',
  padding: '16px 24px 24px',
});

export const PreviewTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#262626',
});

export const PreviewContent = styled(Box)({
  flex: 1,
  minHeight: 0,
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '24px',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#d9d9d9',
    borderRadius: '2px',
  },
});

export const PreviewText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
});

export const PreviewAdMark = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
  marginBottom: '8px',
});

export const PreviewAdFooter = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#a6a6a6',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
  marginTop: '8px',
});

export const PreviewImageList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '12px',
});

export const PreviewImage = styled('img')({
  width: '100%',
  maxHeight: '200px',
  objectFit: 'contain',
  borderRadius: '6px',
  display: 'block',
  backgroundColor: '#f9f9f9',
});

export const RemainingRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  flexShrink: 0,
  boxSizing: 'border-box',
  // 사진첨부 행과 시작점을 맞추기 위해 동일 높이 유지
  height: '64px',
  padding: '10px 12px 10px 20px',
  backgroundColor: '#f7f8fa',
  border: '1px solid #ebedf0',
  borderRadius: '12px',
});

export const RemainingInfo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const RemainingLabel = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
});

export const RemainingCountBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const RemainingCount = styled(Typography)({
  fontSize: '20px',
  fontWeight: 500,
  color: '#262626',
});

export const RemainingUnit = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  color: '#262626',
});

export const ChargeButton = styled(Button)({
  width: '104px',
  height: '40px',
  borderRadius: '8px',
  border: '1px solid #4ab3bc',
  backgroundColor: '#fff',
  color: '#4ab3bc',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(74, 179, 188, 0.08)',
    border: '1px solid #4ab3bc',
  },
});

// ============================================
// Footer Buttons
// ============================================
export const ButtonRow = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexShrink: 0,
});

export const CancelButton = styled(Button)({
  width: '120px',
  height: '48px',
  borderRadius: '8px',
  backgroundColor: '#d9d9d9',
  color: '#262626',
  fontSize: '20px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#c0c0c0',
    boxShadow: 'none',
  },
});

export const SendButton = styled(Button)({
  width: '240px',
  height: '48px',
  borderRadius: '8px',
  backgroundColor: '#4ab3bc',
  color: '#fff',
  fontSize: '20px',
  fontWeight: 600,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#3a9fa8',
    boxShadow: 'none',
  },
});

// ============================================
// Tooltip Icon
// ============================================
export const HelpIconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '20px',
  height: '20px',
  cursor: 'pointer',
});

// ============================================
// 광고성 문자 — 수신 미동의 제외 사전 안내
// ============================================
export const AdExcludeNotice = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  margin: '8px 0 0',
  padding: '10px 12px',
  borderRadius: '8px',
  border: '1px solid #f2c9c0',
  backgroundColor: '#fdf3f1',
  fontSize: '13px',
  lineHeight: 1.5,
  color: '#8a3524',
});

export const AdExcludeHint = styled(Typography)({
  fontSize: '12px',
  color: '#737373',
});

